import { RefreshCcw } from 'lucide-react';
import { useIntl } from 'react-intl';
import { useRecoilValue } from 'recoil';
import ToolbarButton from '~/components/toolbar/shared/ToolbarButton';
import { viewManagerState } from '~/state/atoms/engineAtoms';

export default function ResetViewTool() {
    const viewManager = useRecoilValue(viewManagerState);
    const intl = useIntl();

    const handleClick = (): void => {
        viewManager?.resetViews();
    };

    return (
        <ToolbarButton
            icon={<RefreshCcw />}
            tooltip={intl.formatMessage({
                id: 'toolbar.resetView.tooltip',
            })}
            onClick={handleClick}
            data-testid="reset-view-button"
        />
    );
}
